import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

const Sidebar = ({ showSidebar }) => {
  const location = useLocation();

  return (
    <>
      <nav
        className={`sidebar sidebar-offcanvas ${showSidebar ? "active" : ""}`}
        id="sidebar"
      >
        <ul className="nav">
          <li
            className={`nav-item ${
              location.pathname === "/dashboard" ? "active" : ""
            }`}
          >
            <NavLink className="nav-link" to="/dashboard">
              <i className="mdi mdi-home menu-icon" />
              <span className="menu-title">Dashboard</span>
            </NavLink>
          </li>
          <li
            className={`nav-item ${
              location.pathname === "/company-details" ? "active" : ""
            }`}
          >
            <NavLink className="nav-link" to="/company-details">
              <i className="mdi mdi-office-building menu-icon" />
              <span className="menu-title">Company Details</span>
            </NavLink>
          </li>
          <li
            className={`nav-item ${
              location.pathname === "/party-name" ? "active" : ""
            }`}
          >
            <NavLink className="nav-link" to="/party-name">
              <i className="mdi mdi mdi-tooltip-account menu-icon" />
              <span className="menu-title">Party Details</span>
            </NavLink>
          </li>
          <li
            className={`nav-item ${
              location.pathname === "/products" ||
              location.pathname === "/products-details" ||
              location.pathname === "/company-yard" ||
              location.pathname === "/yard-details"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link"
              data-toggle="collapse"
              href="#ui-basic"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i className="mdi mdi-factory menu-icon" />
              <span className="menu-title">Production</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="ui-basic">
              <ul className="nav flex-column sub-menu">
                <li
                  className={`nav-item ${
                    location.pathname === "/products" ? "active" : ""
                  }`}
                >
                  <NavLink className="nav-link" to="/products">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Products
                  </NavLink>
                </li>
                <li
                  className={`nav-item ${
                    location.pathname === "/products-details" ? "active" : ""
                  }`}
                >
                  <NavLink className="nav-link" to="/products-details">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Products
                    Details
                  </NavLink>
                </li>
                <li
                  className={`nav-item ${
                    location.pathname === "/company-yard" ? "active" : ""
                  }`}
                >
                  <NavLink className="nav-link" to="/company-yard">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Yard
                  </NavLink>
                </li>
                <li
                  className={`nav-item ${
                    location.pathname === "/yard-details" ? "active" : ""
                  }`}
                >
                  <NavLink className="nav-link" to="/yard-details">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Yard Details
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li
            className={`nav-item ${
              location.pathname === "/raw-material-details" ||
              location.pathname === "/raw-material-name" ||
              location.pathname === "/material-name" ||
              location.pathname === "/material-consumption"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link"
              data-toggle="collapse"
              href="#raw_material_li"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i className="mdi mdi-warehouse menu-icon" />
              <span className="menu-title">Raw Material</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="raw_material_li">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/raw-material-details">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Raw Material
                    Details
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/material-name">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Material Name
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/raw-material-name">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Materials
                    Incoming
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/material-consumption">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Materials
                    Consumption
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li
            className={`nav-item ${
              location.pathname === "/discom-list" ||
              location.pathname === "/region-list" ||
              location.pathname === "/govt-rate-list" ||
              location.pathname === "/tkcs-rate-list" ||
              location.pathname === "/private-rate-list" ||
              location.pathname === "/rate-list"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link"
              data-toggle="collapse"
              href="#rate_list_li"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i className="mdi mdi-clipboard-list menu-icon" />
              <span className="menu-title">Rate List</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="rate_list_li">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/discom-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Discom List
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/govt-rate-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Govt Circle
                    Rate List
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/region-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Region List
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/tkcs-rate-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; TKCS Rate List
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/private-rate-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Private Rate
                    List
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink className="nav-link" to="/rate-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Rate List
                  </NavLink>
                </li> */}
              </ul>
            </div>
          </li>
          <li
            className={`nav-item ${
              location.pathname === "/view-private-order" ||
              location.pathname === "/TKCS-order-detials" ||
              location.pathname === "/govt-order"
                ? // location.pathname === "/discom-list" ||
                  // location.pathname === "/region-list" ||
                  // location.pathname === "/govt-rate-list" ||
                  // location.pathname === "/tkcs-rate-list" ||
                  // location.pathname === "/private-rate-list" ||
                  // location.pathname === "/rate-list"
                  "active"
                : ""
            }`}
          >
            <a
              className="nav-link"
              data-toggle="collapse"
              href="#discom_list_li"
              aria-expanded="false"
              aria-controls="ui-basic"
            >
              <i className="mdi mdi-note menu-icon" />
              <span className="menu-title">Orders</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="discom_list_li">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/view-private-order">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Private Order
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/TKCS-order-detials">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; TKCS Order
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/govt-order">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Govt Order
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink className="nav-link" to="/discom-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Discom List
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/region-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Region List
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/govt-rate-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Govt Circle
                    Rate List
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/tkcs-rate-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; TKCS Rate List
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/private-rate-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Private Rate
                    List
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/rate-list">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Rate List
                  </NavLink>
                </li> */}
              </ul>
            </div>
          </li>

          <li
            className={`nav-item ${
              location.pathname === "/govt-order-number" ||
              location.pathname === "/private-order-party-name" ||
              location.pathname === "/tkcs-order-number-dispatch"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link"
              data-toggle="collapse"
              href="#auth"
              aria-expanded="false"
              aria-controls="auth"
            >
              <i className="mdi mdi-account menu-icon" />
              <span className="menu-title">Supply</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="auth">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/trip-details">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Trip Details
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/govt-order-number">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Govt Order
                    Dispatch
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/private-order-party-name">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Private Order
                    Dispatch
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to="/tkcs-order-number-dispatch"
                  >
                    <i className="fa fa-xs fa-circle"></i> &nbsp; TKCS Order
                    Dispatch
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/material-dispatch">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Material
                    Dispatch
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li
            className={`nav-item ${
              location.pathname === "/compliances" ||
              location.pathname === "/office-utils" ||
              location.pathname === "/staff-details" ||
              location.pathname === "/staff-salary"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link"
              data-toggle="collapse"
              href="#office"
              aria-expanded="false"
              aria-controls="office"
            >
              <i className="mdi mdi-domain menu-icon" />
              <span className="menu-title">Office</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="office">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/compliances">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Compliances
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/office-utils">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Office
                    Equipment
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/staff-details">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Staff Details
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/staff-salary">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Staff Salary
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li
            className={`nav-item ${
              location.pathname === "/vehicle-details" ||
              location.pathname === "/battery-details" ||
              location.pathname === "/tyre-details" ||
              location.pathname === "/vehicle-utilities" ||
              location.pathname === "/pump-details"
                ? "active"
                : ""
            }`}
          >
            <a
              className="nav-link"
              data-toggle="collapse"
              href="#Logistics"
              aria-expanded="false"
              aria-controls="Logistics"
            >
              <i className="mdi mdi-truck-delivery menu-icon" />
              <span className="menu-title">Logistics</span>
              <i className="menu-arrow" />
            </a>
            <div className="collapse" id="Logistics">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/vehicle-details">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Vehicle
                    Details
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/battery-details">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Battery
                    Details
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/tyre-details">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Tyre Details
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/vehicle-utilities">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Vehicle
                    Utilities
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/truck-document">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Truck Document
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/pump-details">
                    <i className="fa fa-xs fa-circle"></i> &nbsp; Pump Details
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li
            className={`nav-item ${
              location.pathname === "/notification-history" ? "active" : ""
            }`}
          >
            <NavLink className="nav-link" to="/notification-history">
              <i className="mdi mdi-information menu-icon" />
              <span className="menu-title">Notification History</span>
            </NavLink>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;
